export const minimalInputSx = {
    '& .MuiOutlinedInput-root': {
        fontSize: '0.75rem',
        py: 0,
        '& fieldset': { borderColor: 'divider' },
        '&:hover fieldset': { borderColor: 'text.secondary' },
    },
}

export const minimalTagSx = {
    fontSize: '0.6875rem',
    bgcolor: 'primary.dark',
    color: 'white',
    px: 1,
    py: 0.25,
    borderRadius: 2,
    display: 'inline-flex',
    alignItems: 'center',
    gap: 0.5,
}
